<b-modal v-model="modal_requirement_177" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">{{ headerTitle }}</div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid requirement177-body">
        <div class="w-100">
          <div class="box-margin-right work-support-message requirement177-message">
            {{ dialogMessage }}
          </div>
        </div>

        <div v-if="showInputForm" class="row no-gutters requirement177-input-row">
          <div class="col-12">
            <div class="w-100 box-margin-right">
              <table class="requirement177-input-table">
                <tbody>
                  <tr>
                    <td class="requirement177-label-cell">{{ $t(`${i18nWsKey}.label_ssid`) }}</td>
                    <td>
                      <b-form-group>
                        <b-form-input v-model="inputSsid" type="text" size="sm"
                          :state="ssidValidationMessage ? false : null" :disabled="isLoading" autocomplete="off" />
                        <b-form-invalid-feedback v-if="ssidValidationMessage">
                          {{ ssidValidationMessage }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                  </tr>
                  <tr>
                    <td class="requirement177-label-cell">{{ $t(`${i18nWsKey}.label_pass`) }}</td>
                    <td>
                      <b-form-group>
                        <b-form-input v-model="inputPass" type="password" size="sm"
                          :state="passValidationMessage ? false : null" :disabled="isLoading" autocomplete="off" />
                        <b-form-invalid-feedback v-if="passValidationMessage">
                          {{ passValidationMessage }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center">
      <b-button v-if="showButtonCancel" size="sm" variant="outline-primary" :disabled="isLoading"
        @click="onCancelClicked" class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" variant="primary" :disabled="isLoading" @click="onOkClicked" class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>